<template>
  <div>
    <heads :more="showMore" :msg="title_msg"></heads>
    <van-list
      v-show="isShow"
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div v-for="(thread, index) in list" :key="index" @click="go_url(thread)">
        <datalists
          :type="1"
          :listType="2"
          :thumb="thread.pic"
          :atitle="thread.title"
          :createTime="thread.create_time"
          :vNum="thread.view_num"
          :cNum="thread.reply_num"
        ></datalists>
      </div>
    </van-list>
    <div v-show="!isShow" class="kongzt">
      <img src="@/assets/new_kong.png" alt />
      <p>您还没有发布帖子哦~</p>
    </div>
  </div>
</template>

<script>
import heads from "@/components/common/heads.vue";
import { my_fatie } from "@/api/my_user.js";
import commontop from '@/components/common/menu.vue'
import tool from '@/utils/tools.js'
import datalists from '@/components/datalist'
import Cookies from 'js-cookie'

export default {
  components: {
    heads,
    commontop,
    datalists
  },
  data () {
    return {
      title_msg: "我的发帖",
      list: [],
      times: '',
      isshow: false,
      limit: 10,
      page: 1,
      total: 0,
      retlen: 0,
      loading: false,
      finished: false,
      isShow: true,
      showMore: true,
      uid: Cookies.get('uid') ? Cookies.get('uid') : ''
    };
  },
  destroyed () {
    this.list = []
    this.page = 1
    this.total = 0
  },
  beforeMount () {
    if (tool.isInApp()) {
      if (tool.isInIosApp()) {
        window.onpageshow = function (e) {
          if (e.persisted) {
            window.location.reload()
          }
        }
      }
    }
  },
  methods: {
    go_url (item) {
      const url = '/bbsgroup/d/'+item.tid + '.html'
      location.href = url
    },
    clicks () {
      if (this.isshow == false) {
        this.isshow = true
      } else {
        this.isshow = false
      }
    },
    onLoad () {
      this.loading = true
      console.log(this.uid);
      var params = {
        page: this.page,
        limit: this.limit,
        uid: this.uid
      }
      my_fatie(params).then((res) => {
        const result = res.result
        const count = result.count
        const list = result.list ? result.list : []
        if (!list.length && !this.list.length) {
          this.isShow = false
          return false
        }
        // 加载完成
        this.loading = false
        // 有数据，展示列表
        this.isShow = true
        this.list = this.list.concat(res.result.list)
        // 数据总条数
        this.total = count
        // 本次返回数据的长度
        this.retlen = list.length
        if (this.retlen < this.limit) {
          // 数据加载完毕显示 没有更多了
          this.finished = true
        }
        else {
          // 尚有数据
          this.page++
          this.finished = false
        }
      });
    },
    formatDate (date) {
      var date = new Date(date * 1000);
      return tool.formatDate(date, 'yyyy-MM-dd')
    }
  },
  mounted () {
    // this.get_list();
  },
};
</script>


<style lang="scss" scoped>
.kongzt {
  width: 100%;
  img {
    width: 310px;
    height: 310px;
    margin: 0 auto;
    display: block;
    margin-top: 300px;
  }
  p {
    font-size: 30px;
    font-weight: 600;
    color: #999;
    text-align: center;
    padding-top: 30px;
  }
}
// .img_h {
//   width: 40px;
//   height: 40px;
//   position: absolute;
//   right: 30px;
//   top: 44px;
//   z-index: 1;
// }
// .lists {
//   background-color: #fff;
//   width: 100%;
//   height: 350px;
//   border-bottom: #efefef 1px solid;
//   display: flex;
//   flex-direction: column;
//   justify-content: space-between;
// }
// .listTop {
//   width: 100%;
//   margin-top: 20px;
//   .title {
//     margin: 20px;
//     font-size: 30px;
//     color: #333333;
//     line-height: 50px;
//     word-break: break-all;
//     word-wrap: break-word;
//     overflow: hidden;
//     display: -webkit-box;
//     -webkit-line-clamp: 1;
//     -webkit-box-orient: vertical;
//   }
// }
// .listMid {
//   display: flex;
//   flex-direction: row;
//   justify-content: space-between;
// }
// .midLeft {
//   flex: 1;
//   .userinfo {
//     display: flex;
//     align-items: center;
//     .avatar {
//       margin-left: 20px;
//       width: 50px;
//       height: 50px;
//       border-radius: 50%;
//     }
//     .username {
//       margin-left: 10px;
//       display: inline-block;
//       height: 50px;
//       line-height: 50px;
//       color: #333333;
//       font-size: 24px;
//     }
//   }
//   .content {
//     color: #333333;
//     margin: 20px;
//     font-size: 24px;
//     line-height: 30px;
//     word-break: break-all;
//     word-wrap: break-word;
//     overflow: hidden;
//     display: -webkit-box;
//     -webkit-line-clamp: 2;
//     -webkit-box-orient: vertical;
//   }
// }
// .midRight {
//   width: 279px;
//   height: 157px;
//   margin-right: 20px;
//   .thumb {
//     width: 279px;
//     height: 157px;
//   }
// }
// .listBot {
//   height: 60px;
//   display: flex;
//   flex-direction: row;
//   .botLeft {
//     // width: calc(100% - 280px);
//     flex: 1;
//     height: 60px;
//     line-height: 50px;
//     .view {
//       margin-left: 20px;
//       width: 28px;
//       height: 18px;
//     }
//     .commit {
//       margin-left: 25px;
//       width: 24px;
//       height: 18px;
//     }
//     .view_nunm {
//       display: inline-block;
//       margin-left: 10px;
//       color: #999999;
//       font-size: 20px;
//     }
//     .commit_num {
//       margin-left: 10px;
//       display: inline-block;
//       color: #999999;
//       font-size: 20px;
//     }
//   }
//   .botRight {
//     margin-right: 20px;
//     width: 260px;
//     height: 60px;
//     .bot_time {
//       text-align: right;
//       color: #999999;
//       font-size: 20px;
//       line-height: 50px;
//     }
//   }
// }
</style>
